import { Navbar, Hero } from "@/components/landing/Top";
import { Flow, Previews, UseCases } from "@/components/landing/Sections";
import { Pricing, FAQ, Footer } from "@/components/landing/Bottom";
import { LiveDemo } from "@/components/landing/LiveDemo";
import { Testimonials } from "@/components/landing/Testimonials";
import { UspShowcase } from "@/components/landing/UspShowcase";
import { IntegrationStrip } from "@/components/landing/IntegrationStrip";
import { UploadUsp } from "@/components/landing/UploadUsp";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { PublicChatWidget } from "@/components/assistant/PublicChatWidget";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main>
        <Hero />
        <IntegrationStrip />
        <UspShowcase />
        <LiveDemo />
        <Flow />
        <Previews />
        <UseCases />
        <Testimonials />
        <Pricing />
        <FAQ />
        <UploadUsp />
      </main>
      <Footer />
      <ErrorBoundary silent><PublicChatWidget /></ErrorBoundary>
    </div>
  );
}
